export const ICONS_PATH = '/public/icons';
